export default __webpack_public_path__ + "static/media/boxtype14.33a179ce.JPG";